import WelComeCard from '../../atoms/DashBordCards/WelComeCard'
import PartyCards from '../../atoms/DashBordCards/PartyCards'
import CurateCard from '../../atoms/DashBordCards/CurateCard'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState, useMemo } from 'react'
import { LeaveKazooPopup } from '../../popups/LeaveKazooPopup.jsx'
import { DeleteWeddingPopup } from '../../popups/DeleteWeddingPopup.jsx'
import {
	getKazooDashboard,
	getKazooMembers,
	getCuratedImages,
	getCategoryLineItems,
	fetchKazooDetailsNew,
} from '../../../features/kazooEventSlice.js'
import { getWeddingOnboardingInitialState } from '../../../constants/weddingOnboarding'
import WeddingDate from '../../../pages/onboarding/NewWeddingModal/WeddingDate'
import ButtonCustom from '../../atoms/button/ButtonCustom.jsx'
import CuratedListCard from '../CuratedListCard.jsx'
import { Scheduler } from '../../scheduler/Scheduler.jsx'
import { TimeLineProfileFilters } from '../../../pages/timeline/TimeLineProfileFilters.jsx'
import {
	getEvents,
	setSelectedUsers,
} from '../../../features/schedulerSlice.js'
import { getKazooGuests } from '../../../features/userSlice.js'
import { getKazooProposals } from '../../../features/proposalSlice.js'
import {
	Box,
	Checkbox,
	FormControlLabel,
	Grid,
	LinearProgress,
	Stack,
	styled,
	Typography,
} from '@mui/material'
import WeddingCard from '../../atoms/wedding-card/WeddingCard.jsx'
import { PieChart, useDrawingArea } from '@mui/x-charts'
import VendorTrackerTable from './VendorTrackerTable.jsx'

import styles from './WeddingDashboard.module.scss'
import Progress from './Survey/Progress/Progress.jsx'
import { useTutorial } from '../../../context/TutorialContext.js'
import { useTutorialStatus } from '../../../hooks/useTutorialStatus.js'
import { formatCommonAmount } from '../../../util/formatAmount.js'

const size = {
	width: 170,
	height: 154,
}

function WeddingDashboard() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { kazooId } = useParams()

	const [open, setOpen] = useState(false)
	const [step, setStep] = useState(0)
	const [weddingData, setWeddingData] = useState(getWeddingOnboardingInitialState)

	const handleNext = () => {
		if (step === steps.length - 1) {
			handleClose()
		} else {
			setStep((prev) => prev + 1)
		}
	}

	const handleBack = () => {
		if (step === 0) {
			handleClose()
		} else {
			setStep((prev) => Math.max(prev - 1, 0))
		}
	}

	const handleClose = () => {
		setWeddingData(getWeddingOnboardingInitialState())
		setOpen(false)
		setStep(0)
	}

	const steps = [
		<WeddingDate
			key="wedding-date"
			weddingData={weddingData}
			setWeddingData={setWeddingData}
			handleNext={handleNext}
			handleBack={handleBack}
			open={open && step === 0}
			handleClose={handleClose}
			kazooId={kazooId}
			mode="edit"
		/>,
	]

	const [popupToggle, setPopupToggle] = useState(false)

	const dashboardData = useSelector((state) => state.kazooEvent.dashboardData)
	const user = useSelector((state) => state.auth.user)
	const kazooMembers = useSelector((state) => state.kazooEvent.kazooMembers)
	const selectedImages = useSelector(
		(state) => state.kazooEvent.selectedImages
	)
	const timelineUsers = useSelector((state) => state.scheduler.selectedUsers)
	const timelineEvents = useSelector(
		(state) => state.scheduler.timelineEvents
	)
	const role = useSelector((state) => state.kazooEvent.role)
	const categoryBreakdown = useSelector(
		(state) => state.kazooEvent.mostExpensiveCategories
	)
	const allocatedPercentage = useSelector(
		(state) => state.kazooEvent.allocatedPercentage
	)
	const totalBudget = useSelector((state) => state.kazooEvent.budget)
	const permissions = useSelector((state) => state.kazooEvent?.permissions)
	const rawKazooDate = useSelector((state) => state.kazooEvent.kazooDate)
	const kazooDetails = useSelector((state) => state.kazooEvent.kazooDetails)

	useEffect(() => {
		if (!open || !kazooId || !kazooDetails) return

		const startVal = kazooDetails.startDate
			? new Date(kazooDetails.startDate)
			: null
		const endVal = kazooDetails.endDate
			? new Date(kazooDetails.endDate)
			: startVal
		const multiDay = Boolean(
			startVal && endVal && startVal.getTime() !== endVal.getTime()
		)

		setWeddingData((prev) => ({
			...getWeddingOnboardingInitialState(),
			...prev,
			kazooName: kazooDetails.kazooName ?? prev.kazooName,
			startDate: startVal,
			endDate: endVal ?? startVal,
			multiDay,
		}))
	}, [open, kazooId, kazooDetails])

	const data = [
		{ value: allocatedPercentage, label: 'Allocated', color: '#7CA6BD' },
		{
			value: 100 - allocatedPercentage,
			label: 'Unallocated',
			color: '#D6E3EB',
		},
	]

	const togglePopup = () => {
		setPopupToggle((prev) => !prev)
	}

	const bride = kazooMembers.bride
	const groom = kazooMembers.groom

	const eventSettings = {
		allowAdding: false,
		allowEditing: false,
		allowDeleting: false,
		allowResizing: false,
		allowDrag: false,
		dataSource: timelineEvents.map((event) => ({
			...event,
		})),
	}
	const { startTutorial, isTutorialActive } = useTutorial()
	const { hasSeenTutorial, isLoading } = useTutorialStatus('wedding-dashboard')
	useEffect(() => {
		if (!isLoading && !hasSeenTutorial && !isTutorialActive() && ['bride', 'groom'].includes(role)
		) {
			const timer = setTimeout(() => {
				startTutorial('wedding-dashboard')
			}, 1000)
			return () => clearTimeout(timer)
		}
	}, [isLoading, hasSeenTutorial, isTutorialActive, startTutorial, role])


	const guestView = role === 'guest'

	useEffect(() => {
		dispatch(getEvents(kazooId)) // to display events
		dispatch(getKazooMembers(kazooId))
		dispatch(getKazooDashboard(kazooId))
		dispatch(getKazooGuests(kazooId))
		dispatch(getKazooProposals(kazooId))
		dispatch(getCategoryLineItems(kazooId))
		dispatch(getCuratedImages(kazooId))
		dispatch(fetchKazooDetailsNew(kazooId))
	}, [dispatch, kazooId])

    useEffect(() => {
        if (guestView) {
			// TODO: add logic if there are more members that have calendars here
			let users = [
				{
					preferredName: 'Guests',
					_id: 'guests',
					selected: true,
				},
			]

			users = users.map((user) => ({
				Id: user._id,
				OwnerText:
					user.preferredName || `${user.firstName} ${user.lastName}`,
			}))

			dispatch(setSelectedUsers(users))
		}
    }, [guestView])

	const StyledText = styled('text')(({ theme }) => ({
		fill: theme.palette.text.primary,
		textAnchor: 'middle',
		dominantBaseline: 'central',
		fontSize: 'var(--h6)',
		fontWeight: 'bold',
		wordBreak: 'break-word',
		maxWidth: '30px !important',
		width: '10px !important',
	}))

	function PieCenterLabel({ children }) {
		const { width, height, left, top } = useDrawingArea()
		return (
			<StyledText x={left + width / 2} y={top + height / 2}>
				{children}
			</StyledText>
		)
	}

	const upcomingTasks = useMemo(() => {
        if(!timelineEvents?.length) return []
		const today = new Date()

		const items = timelineEvents.map((t) => {
			const when = t.EndTime || t.StartTime
			const d = when ? new Date(when) : null

			return {
				id: String(t._id || t.id),
				title: t.Subject || 'Untitled Task',
				dateISO: d && !isNaN(d.valueOf()) ? d.toISOString() : null,
				status: (t.status || 'Active').toLowerCase(),
			}
		})

		const filtered = items.filter((x) => {
			if (!x.dateISO) return false
			const d = new Date(x.dateISO)
			const isFutureOrToday = d >= new Date(today.toDateString())
			const notCompleted = x.status !== 'completed'
			return isFutureOrToday && notCompleted
		})

		filtered.sort((a, b) => new Date(a.dateISO) - new Date(b.dateISO))
		return filtered.slice(0, 4).map((x) => ({
			id: x.id,
			title: x.title,
			date: x.dateISO.slice(0, 10),
		}))
	}, [timelineEvents])

	const guests = useSelector((s) => s.user.guests || [])
	const totalGuests = guests.length

	const pendingCount = guests.reduce(
		(acc, g) =>
			acc + (String(g?.status || '').toLowerCase() === 'sent' ? 1 : 0),
		0
	)

	const confirmedCount = Math.max(totalGuests - pendingCount, 0)

	const declinedCount = 0

	const pct = (n) => (totalGuests ? Math.round((n / totalGuests) * 100) : 0)

	const guestStats = [
		{
			title: 'Confirmed',
			count: confirmedCount,
			percent: pct(confirmedCount),
			bgColor: '#EDF7EE',
		},
		{
			title: 'Declined',
			count: declinedCount,
			percent: pct(declinedCount),
			bgColor: '#FDE8E8',
		},
		{
			title: 'Pending',
			count: pendingCount,
			percent: pct(pendingCount),
			bgColor: '#FDF3E8',
		},
	]

	const proposals = useSelector((s) => s.proposal.proposals || []);

	const vendorTrackerTableRows = useMemo(() => {
	return proposals
		.filter(p =>
		String(p?.status).toLowerCase() !== 'deleted' &&
		String(p?.paymentStatus || '').toLowerCase() !== 'cancelled'
		)
		.map((p, idx) => {
		const v = p.vendorId || {};
		const vendorName =
			p.vendorName

		const category =
			v.category || v.serviceType || v.businessCategory || 'N/A';

		const bidAmount =
			typeof p?.bidAmount === 'number'
			? formatCommonAmount(p.bidAmount)
			: '—';

		const status =
			(p.status ? String(p.status) : 'New')
			.replace(/^\w/, c => c.toUpperCase()); 

		return {
			id: p._id ?? `proposal-${idx}`, 
			Vendor: vendorName,
			Category: category,
			BidAmount: bidAmount,
			Status: status,
		};
		});
	}, [proposals])

	const kazooDate = rawKazooDate ? new Date(rawKazooDate) : null

	return (
		<div className={styles.weddingDashboard}>
			<div className={styles.weddingDashboardInner}>
				<WelComeCard
					text={user.preferredName || user.firstName}
					image={kazooMembers.bride?.profilePic}
					image2={kazooMembers.groom?.profilePic}
					alt1="partner1"
					alt2="partner2"
                    hasTimer={true}
                    kazooDate={kazooDate}
                    title={kazooDate ? 'Days Until Your Wedding' : 'Set your wedding date'}
                />
                {
                    !(guestView && !permissions?.moodBoard) &&
                    <CuratedListCard
                        modalsOpen={() => setOpen(true)}
                        images={selectedImages}
                        guestView={guestView}
                    />
                }
			</div>
			{open && <Progress step={step} />}
            <>{steps[step]}</>
            <div className={styles.weddingCardsWrp}>
                <Grid container spacing={2}>
                    {
                        !(guestView && !permissions?.tasks) &&
                        <Grid size={{ xs: 12, md: 6 }}>
                            <WeddingCard
                                heading="Upcoming Tasks"
                                actionLabel={guestView ? undefined : "View All Tasks"}
                                handleAction={() =>
                                    navigate(`/wedding/tasks/${kazooId}`)
                                }
                            >
                                {upcomingTasks.length > 0 ? (
                                <ul className={styles.taskList}>
                                    {(upcomingTasks.length ? upcomingTasks : []).map((task) => (
                                        <li key={task.id} style={{ overflow: 'hidden' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={false}
                                                        sx={{
                                                            color: '#DFE4EB',
                                                            padding: '4px',
                                                            width: 18,
                                                            height: 18,
                                                            borderRadius:
                                                                '50%',

                                                            '& .MuiSvgIcon-root':
                                                                {
                                                                    borderRadius:
                                                                        '50%',
                                                                    width: 18,
                                                                    height: 18,
                                                                },
                                                            '&.MuiButtonBase-root':
                                                                {
                                                                    marginRight:
                                                                        '8px',
                                                                },

                                                            '&.Mui-checked':
                                                                {
                                                                    color: '#7CA6BD',
                                                                },
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            gap: '2px',
                                                            fontSize:
                                                                '14px',
                                                            fontWeight:
                                                                '600',
                                                            color: '#313131',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                maxWidth:
                                                                    '100%',
                                                                overflow:
                                                                    'hidden',
                                                                textOverflow:
                                                                    'ellipsis',
                                                                whiteSpace:
                                                                    'nowrap',
                                                            }}
                                                        >
                                                            {task.title}
                                                        </div>
                                                        <span
                                                            style={{
                                                                fontSize:
                                                                    '12px',
                                                                fontWeight:
                                                                    '400',
                                                                color: '#8692A4',
                                                                width: 'fit-content',
                                                            }}
                                                        >
                                                            Due: {task.date}
                                                        </span>
                                                    </div>
                                                }
                                                sx={{
                                                    '&.MuiFormControlLabel-root':
                                                        {
                                                            margin: '0 !important',
                                                            display: 'flex',
                                                        },
                                                    '& .MuiFormControlLabel-label':
                                                        {
                                                            fontSize:
                                                                '14px',
                                                            fontWeight:
                                                                '400',
                                                            color: '#313131',
                                                            maxWidth:
                                                                'calc(100% - 30px)',
                                                        },
                                                }}
                                            />
                                        </li>
                                    ))}
                                </ul>
                                ) : (
                                <div
                                    style={{
                                        textAlign: 'center',
                                        padding: '1.5rem 0',
                                        color: '#8692A4',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                    }}
                                    >
                                    No upcoming tasks yet. 
                                    {!guestView &&
                                        <>
                                            Add one in your{' '}
                                            <b
                                                style={{
                                                color: '#7CA6BD',
                                                cursor: 'pointer',
                                                textDecoration: 'underline',
                                                }}
                                                onClick={() => navigate(`/wedding/tasks/${kazooId}`)}
                                            >
                                                Tasks
                                            </b>{' '}
                                            page to see it here!
                                        </>
                                    }
                                </div>
                            )}
                            </WeddingCard>
                        </Grid>
                    }
                    {
                        !(guestView && !permissions?.budget) &&
                        <Grid size={{ xs: 12, md: 6 }}>
                            <WeddingCard
                                heading={`Total Budget: $${totalBudget.toLocaleString()}`}
                                actionLabel={guestView ? undefined : "View Details"}
                                handleAction={() =>
                                    navigate(
                                        `/wedding/budget-tracker/${kazooId}`
                                    )
                                }
                            >
                                <div className={styles.budgetRow}>
                                    <div className={styles.chartWrp}>
                                        <PieChart
                                            series={[
                                                {
                                                    data,
                                                    innerRadius: 45,
                                                    outerRadius: 65,
                                                },
                                            ]}
                                            {...size}
                                            slotProps={{
                                                legend: {
                                                    direction: 'row',
                                                    position: {
                                                        vertical: 'bottom',
                                                        horizontal:
                                                            'middle',
                                                    },
                                                    // padding: { top: 8 },
                                                    sx: {
                                                        mt: 2,
                                                        '&.MuiChartsLegend-root':
                                                            {
                                                                gap: '15px',
                                                                justifyContent:
                                                                    'center',
                                                            },
                                                        '& .MuiChartsLegend-mark':
                                                            {
                                                                width: '8px !important',
                                                                height: '8px !important',
                                                                borderRadius:
                                                                    '50%',
                                                                marginRight:
                                                                    '8px',
                                                            },
                                                        '& .MuiChartsLegend-label':
                                                            {
                                                                fontSize:
                                                                    '12px',
                                                                fontWeight:
                                                                    '400',
                                                                fontFamily:
                                                                    'Inter',
                                                                color: '#8692A4',
                                                            },
                                                        '& .MuiChartsLegend-series':
                                                            {
                                                                margin: '0',
                                                                display:
                                                                    'flex',
                                                                gap: '0',
                                                                alignItems:
                                                                    'center',
                                                            },
                                                    },
                                                },
                                            }}
                                        >
                                            <PieCenterLabel>
                                                <tspan
                                                    fill="var(--secondary-Text)"
                                                    fontWeight="400"
                                                    fontSize="12px"
                                                    display="block"
                                                    x="50%"
                                                    y="40%"
                                                    dy="0"
                                                    textAnchor="middle"
                                                >
                                                    Used
                                                </tspan>
                                                <tspan
                                                    fill="#000000"
                                                    fontWeight="600"
                                                    fontSize="20px"
                                                    display="block"
                                                    x="50%"
                                                    y="50%"
                                                    dy="0.5em"
                                                    textAnchor="middle"
                                                >
                                                    {data[0].value}%
                                                </tspan>
                                            </PieCenterLabel>
                                        </PieChart>
                                    </div>
                                    <div
                                        className={styles.categoryBreakdown}
                                    >
                                        <Typography
                                            variant="h5"
                                            className={styles.cardTitle}
                                        >
                                            Category Breakdown
                                        </Typography>
                                        <div
                                            className={styles.allocatedCol}
                                        >
                                            {!categoryBreakdown.length && (
                                                <Typography>
                                                    ... None allocated
                                                </Typography>
                                            )}
                                            {categoryBreakdown.map(
                                                (item, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            gap: '8px',
                                                        }}
                                                    >
                                                        <div
                                                            className={
                                                                styles.allocatedAmount
                                                            }
                                                        >
                                                            <Typography variant="h5">
                                                                {item.title}
                                                            </Typography>
                                                            <Typography variant="h6">
                                                                {
                                                                    item.amount
                                                                }
                                                            </Typography>
                                                        </div>
                                                        <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            spacing={2}
                                                        >
                                                            <LinearProgress
                                                                variant="determinate"
                                                                value={
                                                                    item.percent
                                                                }
                                                                sx={{
                                                                    flexGrow: 1,
                                                                    height: 8,
                                                                    borderRadius: 4,
                                                                    backgroundColor:
                                                                        '#FAF4F2',
                                                                    '& .MuiLinearProgress-bar':
                                                                        {
                                                                            backgroundColor:
                                                                                '#7CA6BD',
                                                                            borderRadius: 4,
                                                                        },
                                                                }}
                                                            />
                                                        </Stack>
                                                    </Box>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </WeddingCard>
                        </Grid>
                    }
                    {
                        !(guestView && !permissions?.vendorTracker) &&
                        <Grid size={{ xs: 12, md: 6 }}>
                            <WeddingCard
                                heading="Vendor Tracker"
                                actionLabel={guestView ? undefined : "View Details"}
                                handleAction={() => navigate(`/wedding/vendors/${kazooId}`)}
                            >
                                {vendorTrackerTableRows.length > 0 ? (
                                <VendorTrackerTable rows={vendorTrackerTableRows} />
                                ) : (
                                <Typography variant="body2" sx={{ color: '#8692A4' }}>
                                    No vendor proposals yet.
                                </Typography>
                                )}
                            </WeddingCard>
                        </Grid>
                    }
                    {/* TODO: implement logic for total guests when guest RSVP is developed */}
                    
                    {/* {
                        !(guestView && !permissions?.guests) &&
                        <Grid size={{ xs: 12, md: 6 }}>
                            <WeddingCard
                                heading={`Total Guests: ${totalGuests}`}
                                actionLabel={guestView ? undefined : "View Details"}
                                handleAction={() => navigate(`/wedding/wedding-guests/${kazooId}`)}
                            >
                                <div className={styles.guestsWrp}>
                                    <Grid container spacing={{ xs: '8px', md: '16px' }}>
                                        {guestStats.map((item) => (
                                            <Grid size={{ xs: 4, md: 4 }} key={item.title}>
                                                <div
                                                    className={styles.guestsCardWrp}
                                                    style={{ backgroundColor: item.bgColor }}
                                                >
                                                    <Typography variant="h5">{item.count}</Typography>
                                                    <div className={styles.info}>
                                                        <Typography variant="h6">{item.title}</Typography>
                                                        {item.title === 'Declined' ? (
                                                            <span style={{ fontSize: '11px', color: '#8692A4' }}>
                                                            Feature coming soon
                                                            </span>
                                                        ) : (
                                                            <span>{item.percent}%</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </div>
                            </WeddingCard>
                        </Grid>
                    } */}
                </Grid>
            </div>
            {
                !guestView &&
                <WeddingCard heading="Your Party">
                    <div className={styles.yourParty}>
                        <div className={styles.partyCards}>
                            <TimeLineProfileFilters />
                        </div>
                    </div>
                </WeddingCard>
            }

            {
                !(guestView && !permissions?.timeline) &&
                <div className={styles.yourWeddingDayTimeline}>
                    <div className={styles.calendarHeading}>
                        <h2 className={styles.weddingDashboardHeading}>
                            {!guestView
                                ? 'Your Wedding Events Schedule'
                                : dashboardData.kazooName}
                        </h2>
                    </div>

                    <div
                        className={styles.calendarHeading}
                        style={{ marginTop: '30px' }}
                    >
                        <div className={styles.schedulerWrap}>
                            <div className="calendarWrp commonCalendar ">
                                <div className="calendarInner">
                                    <Scheduler
                                        eventSettings={eventSettings}
                                        partyMembers={timelineUsers}
                                        allowResizing={false}
                                        allowDragAndDrop={false}
                                        height="77dvh"
                                        guestView={guestView}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div style={{ flex: '0 0 auto', paddingTop: '1em' }}>
                {user._id !== dashboardData.ownerId ? (
                    <>
                        <ButtonCustom
                            onClick={togglePopup}
                            data-cy="leave-wedding"
                        >
                            Leave Wedding
                        </ButtonCustom>
                        {popupToggle && (
                            <LeaveKazooPopup
                                popupToggle={popupToggle}
                                userId={user._id}
                                kazooId={kazooId}
                                clickHandler={togglePopup}
                            />
                        )}
                    </>
                ) : (
                    <>
                        <ButtonCustom
                            onClick={togglePopup}
                            data-cy="delete-wedding"
                        >
                            Delete Wedding
                        </ButtonCustom>
                        {popupToggle && (
                            <DeleteWeddingPopup
                                popupToggle={popupToggle}
                                kazooId={kazooId}
                                clickHandler={togglePopup}
                            />
                        )}
                    </>
                )}
            </div>
		</div>
	)
}

export default WeddingDashboard
